// The shape of a SIREN, once for the whole product: the route that creates a
// dossier and the form that previews its identity accept exactly the same
// thing. Nine digits, spaces tolerated because that is how a SIREN is printed
// (« 842 193 507 »).

const SIREN_SHAPE = /^\d{9}$/;

/** « 842 193 507 » → « 842193507 »; anything but nine digits gives null. */
export function normalizeSiren(raw: string): string | null {
  const compact = raw.replace(/\s+/g, "");
  return SIREN_SHAPE.test(compact) ? compact : null;
}
